module.exports = __webpack_public_path__ + "img/9.4ec5abfe.png";